var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tab-detail" }, [
    _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("youtubeChannel.visibilitySettings"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "subtitle" }, [
        _vm._v(_vm._s(_vm.$t("youtubeChannel.visibilityDescription"))),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-wrapper" }, [
      _c(
        "div",
        { staticClass: "input-wrapper" },
        [
          _c("label", [_vm._v(_vm._s(_vm.$t("youtubeChannel.users")))]),
          _vm._v(" "),
          _c(
            "a-select",
            {
              staticStyle: { width: "100%" },
              attrs: {
                mode: "multiple",
                placeholder: _vm.$t("youtubeChannel.selectUsers"),
                "filter-option": _vm.filterOption,
              },
              model: {
                value: _vm.form.users,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "users", $$v)
                },
                expression: "form.users",
              },
            },
            _vm._l(_vm.users, function (user) {
              return _c(
                "a-select-option",
                { key: user._id, attrs: { value: user._id } },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(user.fullName) +
                      "\n                "
                  ),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "input-wrapper" },
        [
          _c("label", [_vm._v(_vm._s(_vm.$t("youtubeChannel.departments")))]),
          _vm._v(" "),
          _c(
            "a-select",
            {
              staticStyle: { width: "100%" },
              attrs: {
                mode: "multiple",
                placeholder: _vm.$t("youtubeChannel.selectDepartments"),
                "filter-option": _vm.filterOption,
              },
              model: {
                value: _vm.form.departments,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "departments", $$v)
                },
                expression: "form.departments",
              },
            },
            _vm._l(_vm.departments, function (dept) {
              return _c(
                "a-select-option",
                { key: dept._id, attrs: { value: dept._id } },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(dept.name) +
                      "\n                "
                  ),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "input-wrapper" },
        [
          _c("label", [_vm._v(_vm._s(_vm.$t("youtubeChannel.owners")))]),
          _vm._v(" "),
          _c(
            "a-select",
            {
              staticStyle: { width: "100%" },
              attrs: {
                mode: "multiple",
                placeholder: _vm.$t("youtubeChannel.selectOwners"),
                "filter-option": _vm.filterOption,
              },
              model: {
                value: _vm.form.owners,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "owners", $$v)
                },
                expression: "form.owners",
              },
            },
            _vm._l(_vm.users, function (user) {
              return _c(
                "a-select-option",
                { key: user._id, attrs: { value: user._id } },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(user.fullName) +
                      "\n                "
                  ),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-footer" }, [
      _c(
        "div",
        { staticClass: "actions" },
        [
          _c(
            "a-button",
            {
              staticClass: "pr-confirm-btn",
              attrs: { type: "primary", loading: _vm.loading },
              on: { click: _vm.handleSave },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("message.update")) +
                  "\n            "
              ),
            ]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }